import React, { ReactNode } from 'react';

import { ScreenHome } from '@fhs/app';

import useAuth from 'hooks/auth/use-auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useExperiment } from './utils';

type SimplifiedLandingPageExperimentProps = {
  children: ReactNode;
};

export function SimplifiedLandingPage__Experiment(props: SimplifiedLandingPageExperimentProps) {
  const { isAuthenticated } = useAuth();
  const isCateringEnabled = useFlag(LaunchDarklyFlag.ENABLE_CATERING);
  const isDeliveryEnabled = useFlag(LaunchDarklyFlag.ENABLE_DELIVERY);

  if (useExperiment() === 'control') {
    return <>{props.children}</>;
  }

  return (
    <ScreenHome
      isSignedIn={isAuthenticated}
      isCateringEnabled={isCateringEnabled}
      isDeliveryEnabled={isDeliveryEnabled}
    />
  );
}
